import React from "react";
import withLabel from "./withLabel";
import withFormBindings from "./withFormBindings";

const MessageField = (props) => <textarea {...props} col="24" rows="10" className="mt2 outline-0 field-padding mid-gray w-100 ba b--black-20 resize-none" />

export default withFormBindings(withLabel(MessageField))